import type { ThemeButton, ThemePreference } from "../theme/theme";

const BUTTONS: { id: ThemeButton; label: string; symbol: string }[] = [
  { id: "auto", label: "Adapt theme to system", symbol: "◐" },
  { id: "light", label: "Always light theme", symbol: "☀" },
  { id: "dark", label: "Always dark theme", symbol: "☾" },
];

function selected(button: ThemeButton, preference: ThemePreference): boolean {
  if (button === "auto") return preference === null;
  return button === preference;
}

export function ThemeToggle({
  preference,
  onClick,
}: {
  preference: ThemePreference;
  onClick: (button: ThemeButton) => void;
}) {
  return (
    <div className="flex gap-1" role="group" aria-label="Theme">
      {BUTTONS.map((b) => (
        <button
          key={b.id}
          type="button"
          title={b.label}
          aria-label={b.label}
          aria-pressed={selected(b.id, preference)}
          onClick={() => onClick(b.id)}
          className={
            "h-8 w-8 rounded-md border border-[var(--border)] text-sm " +
            (selected(b.id, preference)
              ? "bg-[var(--color-accent)] text-white"
              : "bg-[var(--surface)] text-[var(--muted)]")
          }
        >
          {b.symbol}
        </button>
      ))}
    </div>
  );
}
